import { Component, HostListener, OnInit, SecurityContext } from '@angular/core';
import { PopupService } from '../../shared/modal/popup.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GERMPLASM_SEARCH_SELECTOR, INVENTORY_DETAILS_URL } from '../../app.constants';
import { ParamContext } from '../../shared/service/param.context';
import { ActivatedRoute } from '@angular/router';
import { JhiEventManager } from '../../shared/core-utils';
import { getUrl } from '../../shared/util/dev-util';
import { UrlService } from '../../shared/service/url.service';

@Component({
    selector: 'jhi-germplasm-selector-modal',
    template: `
			<div class="modal-header">
                <h4 class="modal-title">{{ 'study-editor.germplasm-selector.modal-title' | translate }}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
                        (click)="clear()">
                </button>
			</div>
            <div class="container" data-test="germplasmSelectorModal">
			<iframe [src]="safeUrl" style="border: 0" width="100%" height="720px"></iframe>
		    </div>
    `
})
export class GermplasmSelectorModalComponent implements OnInit {

    selectMultiple: boolean;
    selectorValue;
    safeUrl: SafeResourceUrl;

    constructor(public activeModal: NgbActiveModal,
                private paramContext: ParamContext,
                private sanitizer: DomSanitizer,
                private eventManager: JhiEventManager,
                private urlService: UrlService) {
    }

    @HostListener('window:message', ['$event'])
    onMessage(event) {
        if (event.data.name === 'selector-changed') {
            this.eventManager.broadcast({ name: 'germplasmSelectorSelected', content: event.data.value.join(',') });
            this.clear();
        } else if (event.data.name === 'cancel') {
            this.clear();
        }
    }

    ngOnInit(): void {
        const queryParams = '?cropName=' + this.paramContext.cropName
            + '&programUUID=' + this.paramContext.programUUID
            + '&selectedProjectId=' + this.paramContext.selectedProjectId
            + '&loggedInUserId=' + this.paramContext.loggedInUserId
            + '&selectMultiple=' + this.selectMultiple; // Tell the page that it is shown as a modal.
        const urlStr = this.urlService.buildSafeUrl(GERMPLASM_SEARCH_SELECTOR + queryParams);
        this.safeUrl = urlStr !== null
            ? this.sanitizer.bypassSecurityTrustResourceUrl(urlStr)
            : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

}

@Component({
    selector: 'jhi-germplasm-selector-popup',
    template: ''
})
export class GermplasmSelectorPopupComponent implements OnInit {

    selectMultiple: boolean;

    constructor(private popupService: PopupService, private activatedRoute: ActivatedRoute, ) {
        const queryParams = this.activatedRoute.snapshot.queryParams;
        this.selectMultiple = queryParams.selectMultiple === 'true';
    }

    ngOnInit(): void {
        const modal = this.popupService.open(GermplasmSelectorModalComponent as Component, { size: 'xl', backdrop: 'static' });
        modal.then((modalRef) => {
            modalRef.componentInstance.selectMultiple = this.selectMultiple;
        });
    }

}
